// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@keyframes circular-animation-3c0d0277{to{stroke-dashoffset:0}}.breadcrumb[data-v-3c0d0277]{background:transparent;margin-bottom:0;padding:.75rem .75rem .75rem 0}.breadcrumb .layer[data-v-3c0d0277]{display:flex}@media(max-width:1024px){.breadcrumb[data-v-3c0d0277]{font-size:14px}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
